var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 102,
    viewBox: "0 0 120 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.5303 76.5986H42.663V95.5051H76.5303V76.5986Z",
    fill: "#27869F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3299 97.028H30.8642C28.1181 97.028 25.8922 99.2539 25.8922 102H93.3015C93.3015 99.2543 91.0756 97.028 88.3295 97.028H88.3299Z",
    fill: "#27869F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5303 76.5986H42.663V83.5035H76.5303V76.5986Z",
    fill: "#27869F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90043 0H114.293C116.998 0 119.194 2.19572 119.194 4.90044V74.4567C119.194 77.1614 116.998 79.3571 114.293 79.3571H4.90043C2.19572 79.3571 0 77.1614 0 74.4567V4.90044C0 2.19572 2.19572 0 4.90043 0Z",
    fill: "#27869F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.584 6.40878H5.60971V72.9487H113.584V6.40878Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.18c18ad7961cc2658228df3a8d20f2c5.svg";
export { ForwardRef as ReactComponent };